import Translator from '../../../classes/Translator/Translator';

const SourceLogic = () => {
  const { translator } = Translator();
  return { translator };
};

export default SourceLogic;
